import { QueryClient } from '@tanstack/react-query';
import { EnterpriseDataRoomSuggestedActions } from 'models/EnterpriseSuggestedActions';
import { PaginatedData } from 'models/PaginatedData';
import {
  GeneralSuggestedAction,
  GeneralSuggestedActionType,
} from 'models/SuggestedActions';
import { SuggestedActionType } from 'router/subrouters/DataRoom/models/Dashboard';
import { ENTERPRISE_SUGGESTED_ACTIONS_QUERY_KEY } from './hooks/useEnterpriseSuggestedActionsQuery';
import { GENERAL_SUGGESTED_ACTIONS_QUERY_KEY } from './hooks/useGeneralSuggestedActionsQuery';

export const removeEnterpriseSuggestedAction = (
  queryClient: QueryClient,
  dataRoomId: string,
  type: SuggestedActionType,
) => {
  queryClient.setQueriesData<PaginatedData<EnterpriseDataRoomSuggestedActions>>(
    { queryKey: [ENTERPRISE_SUGGESTED_ACTIONS_QUERY_KEY] },
    (oldData) => {
      if (!oldData) return oldData;

      return {
        ...oldData,
        items: oldData.items.map((dataRoom) =>
          dataRoom.dataRoomId === dataRoomId
            ? {
                ...dataRoom,
                actions: dataRoom.actions.filter((item) => item.type !== type),
              }
            : dataRoom,
        ),
      };
    },
  );

  queryClient.invalidateQueries({
    queryKey: [ENTERPRISE_SUGGESTED_ACTIONS_QUERY_KEY],
  });
};

export const removeGeneralSuggestedAction = (
  queryClient: QueryClient,
  type: GeneralSuggestedActionType,
) => {
  queryClient.setQueriesData<GeneralSuggestedAction[]>(
    { queryKey: [GENERAL_SUGGESTED_ACTIONS_QUERY_KEY] },
    (oldData) =>
      oldData ? oldData.filter((item) => item.type !== type) : oldData,
  );

  queryClient.invalidateQueries({
    queryKey: [GENERAL_SUGGESTED_ACTIONS_QUERY_KEY],
  });
};
